import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReferralTrackingState, ReferralTrackerAnalytics, ReferralTrackingData, TopInvitersData } from "./types";
import { fetchReferralTrackingAnalytics, fetchReferralTrackingData, fetchTopInvitersData } from "./actions";

const initialState: ReferralTrackingState = {
  analytics: null,
  analyticsLoading: "idle",
  analyticsError: null,
  data: null,
  dataLoading: "idle",
  dataError: null,
  topInviters: null,
  topInvitersLoading: "idle",
  topInvitersError: null,
};

const referralTrackerSlice = createSlice({
  name: "referralTracker",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReferralTrackingAnalytics.pending, (state) => {
        state.analyticsLoading = "pending";
        state.analyticsError = null;
      })
      .addCase(
        fetchReferralTrackingAnalytics.fulfilled,
        (state, action: PayloadAction<ReferralTrackerAnalytics>) => {
          state.analyticsLoading = "succeeded";
          state.analytics = action.payload;
        }
      )
      .addCase(fetchReferralTrackingAnalytics.rejected, (state, action: PayloadAction<any>) => {
        state.analyticsLoading = "failed";
        state.analyticsError = action.payload?.message || "Failed to fetch pro accounts analytics data";
      })
      
      .addCase(fetchReferralTrackingData.pending, (state) => {
        state.dataLoading = "pending";
        state.dataError = null;
      })
      .addCase(
        fetchReferralTrackingData.fulfilled,
        (state, action: PayloadAction<ReferralTrackingData>) => {
          state.dataLoading = "succeeded";
          state.data = action.payload;
        }
      )
      .addCase(fetchReferralTrackingData.rejected, (state, action: PayloadAction<any>) => {
        state.dataLoading = "failed";
        state.dataError = action.payload?.message || "Failed to fetch referral tracking data";
      })

      .addCase(fetchTopInvitersData.pending, (state) => {
        state.topInvitersLoading = "pending";
        state.topInvitersError = null;
      })
      .addCase(fetchTopInvitersData.fulfilled,
        (state, action: PayloadAction<TopInvitersData>) => {
          state.topInvitersLoading = "succeeded";
          state.topInviters = action.payload;
        })
      .addCase(fetchTopInvitersData.rejected, (state, action: PayloadAction<any>) => {
        state.topInvitersLoading = "failed";
        state.topInvitersError = action.payload?.message || "Failed to fetch referral tracking data";
      });
    }
})
export default referralTrackerSlice.reducer;
